import { FormControl, TextInput, TextInputProps } from '@primer/react';
import { useCommonContext } from '../../../contexts/common';
import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';

export interface IMyTextInputProps extends TextInputProps {
    register?: any,
    errors?: any,
    validateMessage?: string,
    name?: string,
    required?: boolean,
    minLength?: number,
    maxLength?: number,
    onValueDelayChanged?: (value: any) => void
}
const MyTextInput = (props: IMyTextInputProps) => {
    const { register, errors, validateMessage, required, minLength, maxLength, onValueDelayChanged, ...restProps } = props;
    const { translate } = useCommonContext();
    const [tempValue, setTempValue] = useState<any>(props.value ?? props.defaultValue);
    const tempValueDelayed = useDebounce(tempValue, 300)[0];
    useEffect(() => {
        if (onValueDelayChanged && tempValueDelayed !== (props.value ?? props.defaultValue)) {
            onValueDelayChanged(tempValueDelayed);
        }
    }, [tempValueDelayed]);

    const hasError = Boolean(props.name && errors && errors[props.name]);
    const registered = register && props.name
        ? register(props.name, {
            required: required
                ? {
                    value: true,
                    message: translate(validateMessage ?? "")
                }
                : undefined,
            minLength: minLength
                ? {
                    value: minLength,
                    message: translate(validateMessage ?? "")
                }
                : undefined,
            maxLength: maxLength
                ? {
                    value: maxLength,
                    message: translate(validateMessage ?? "")
                }
                : undefined,
        })
        : null;

    return (
        <>
            {registered && props.name && (
                <>
                    <TextInput
                        {...restProps}
                        {...registered}
                        name={props.name}
                        validationStatus={hasError ? "error" : restProps.validationStatus}
                        onChange={(e) => {
                            registered.onChange(e);
                            setTempValue(e.target.value);
                            if (restProps.onChange) {
                                restProps.onChange(e);
                            }
                        }}
                    />
                    {hasError && (
                        <FormControl.Validation id={props.name} variant="error">
                            <>{errors[props.name].message ?? ""}</>
                        </FormControl.Validation>
                    )}
                </>
            )}
            {(!registered || !props.name) && (
                <TextInput
                    {...restProps}
                    validationStatus={hasError ? "error" : restProps.validationStatus}
                    onChange={(e) => {
                        setTempValue(e.target.value);
                        if (restProps.onChange) {
                            restProps.onChange(e);
                        }
                    }}
                />
            )}
        </>
    );
};

export default MyTextInput;
